import React, { useState, useEffect } from "react";

export default function ListManager({
  type = "list",
  data,
  title = "Vlerat",
  onGetData,
}) {
  const [numberItems, setNumberItems] = useState([]);
  const [listItems, setListItems] = useState({});
  const [newItem, setNewItem] = useState(
    type === "number"
      ? { label: "", min: "", max: "" }
      : { label: "", value: "" }
  );

  const [editItem, setEditItem] = useState(null); // ➕ për modal editimi
  const [editIndexOrKey, setEditIndexOrKey] = useState(null); // ➕

  useEffect(() => {
    if (type === "number") {
      setNumberItems(Array.isArray(data) ? data : []);
    } else {
      setListItems(
        data && typeof data === "object" && !Array.isArray(data) ? data : {}
      );
    }
  }, [data, type]);

  const handleAdd = () => {
    if (!newItem.label) return alert("Indikatori është i detyrueshëm");

    if (type === "number") {
      const min = parseInt(newItem.min);
      const max = parseInt(newItem.max);
      if (isNaN(min) || isNaN(max) || min >= max) {
        return alert("Min duhet të jetë numër më i vogël se Max.");
      }

      const newEntry = { label: newItem.label, min, max };
      const updatedItems = [...numberItems, newEntry];
      setNumberItems(updatedItems);
      onGetData(updatedItems);
      setNewItem({ label: "", min: "", max: "" });
    } else {
      if (!newItem.value) return alert("Vlera është e detyrueshme");

      const updatedItems = {
        ...listItems,
        [newItem.value]: newItem.label,
      };
      setListItems(updatedItems);
      onGetData(updatedItems);
      setNewItem({ label: "", value: "" });
    }
  };

  const handleRemove = (keyOrIndex) => {
    if (type === "number") {
      const updated = numberItems.filter((_, i) => i !== keyOrIndex);
      setNumberItems(updated);
      onGetData(updated);
    } else {
      const updated = { ...listItems };
      delete updated[keyOrIndex];
      setListItems(updated);
      onGetData(updated);
    }
  };

  const handleEdit = (item, keyOrIndex) => {
    setEditItem(item);
    setEditIndexOrKey(keyOrIndex);
  };

  const handleEditSave = () => {
    if (!editItem.label) return alert("Indikatori është i detyrueshëm");

    if (type === "number") {
      const min = parseInt(editItem.min);
      const max = parseInt(editItem.max);
      if (isNaN(min) || isNaN(max) || min >= max) {
        return alert("Min duhet të jetë më i vogël se Max.");
      }

      const updated = [...numberItems];
      updated[editIndexOrKey] = { ...editItem };
      setNumberItems(updated);
      onGetData(updated);
    } else {
      if (!editItem.value) return alert("Vlera është e detyrueshme");

      const updated = { ...listItems };
      delete updated[editIndexOrKey]; // fshi vjetrin
      updated[editItem.value] = editItem.label;
      setListItems(updated);
      onGetData(updated);
    }

    setEditItem(null);
    setEditIndexOrKey(null);
  };

  const handleChange = (field, value) => {
    setNewItem((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <h3>{title}</h3>

      {type === "number"
        ? numberItems.map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
                marginBottom: 8,
              }}
            >
              <div>
                <span>
                  {item.label} (Min: {item.min}, Max: {item.max})
                </span>
              </div>
              <div style={{ display: "flex", gap: 4 }}>
                <button onClick={() => handleEdit(item, index)}>Edito</button>{" "}
                {/* 🛠 */}
                <button onClick={() => handleRemove(index)}>Fshi</button>
              </div>
            </div>
          ))
        : Object.entries(listItems).map(([key, label]) => (
            <div
              key={key}
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
                marginBottom: 8,
              }}
            >
              <div>
                <span>Indikatori: </span>
                <strong>{label}</strong> - <span>Vlera: {key}</span>
              </div>
              <div style={{ display: "flex", gap: 4 }}>
                <button onClick={() => handleEdit({ label, value: key }, key)}>
                  Edito
                </button>
                <button onClick={() => handleRemove(key)}>Fshi</button>
              </div>
            </div>
          ))}

      {/* ➕ Add new item inputs */}
      <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
        <input
          placeholder="Indikatori"
          value={newItem.label}
          onChange={(e) => handleChange("label", e.target.value)}
        />
        {type === "number" ? (
          <>
            <input
              type="number"
              placeholder="Min"
              value={newItem.min}
              onChange={(e) => handleChange("min", e.target.value)}
              style={{ width: 130 }}
            />
            <input
              type="number"
              placeholder="Max"
              value={newItem.max}
              onChange={(e) => handleChange("max", e.target.value)}
              style={{ width: 130 }}
            />
          </>
        ) : (
          <input
            placeholder="Vlera"
            value={newItem.value}
            onChange={(e) => handleChange("value", e.target.value)}
          />
        )}
        <button onClick={handleAdd}>Shto</button>
      </div>

      {/* ➕ Modal për editim */}
      {editItem && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.3)",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 8,
              minWidth: 300,
            }}
          >
            <h4>Edito</h4>
            <input
              placeholder="Indikatori"
              value={editItem.label}
              onChange={(e) =>
                setEditItem((prev) => ({ ...prev, label: e.target.value }))
              }
            />
            {type === "number" ? (
              <>
                <input
                  type="number"
                  placeholder="Min"
                  value={editItem.min}
                  onChange={(e) =>
                    setEditItem((prev) => ({ ...prev, min: e.target.value }))
                  }
                />
                <input
                  type="number"
                  placeholder="Max"
                  value={editItem.max}
                  onChange={(e) =>
                    setEditItem((prev) => ({ ...prev, max: e.target.value }))
                  }
                />
              </>
            ) : (
              <input
                placeholder="Vlera"
                value={editItem.value}
                onChange={(e) =>
                  setEditItem((prev) => ({ ...prev, value: e.target.value }))
                }
              />
            )}
            <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
              <button onClick={handleEditSave}>Ruaj</button>
              <button
                onClick={() => {
                  setEditItem(null);
                  setEditIndexOrKey(null);
                }}
              >
                Anulo
              </button>
            </div>
          </div>
        </div>
      )}

      <h4>Rezultati</h4>
      <pre>
        {JSON.stringify(type === "number" ? numberItems : listItems, null, 2)}
      </pre>
    </div>
  );
}
